<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>基地管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'availabilityReport' }">供应力上报</el-breadcrumb-item>
        <el-breadcrumb-item>历史记录</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="领货日期：">
              <el-select filterable clearable style="width: 100%" v-model="listParams.dateId" placeholder="请选择或搜索领货日期" size="small">
                <el-option v-for="item in dateList" :value="item.dateId" :key="item.dateId" :label="item.date | formatDate"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <hx-table-result-col>
      <div class="wrap-table-info-display" style="height: 32px">
        <span class="table-info-display">
          <span>总条数：</span>
          <span class="alert-text ft16">{{ pager.total }}</span>
        </span>
      </div>
    </hx-table-result-col>

    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column fixed align="center" label="序号">
          <template slot-scope="scope">
            <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
          </template>
        </el-table-column>

        <el-table-column prop="" align="center" fixed label="领货日期">
          <template slot-scope="scope">
            <span v-if="scope.row.date">
              {{ scope.row.date | formatDate(true) }}
            </span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="detailItem(scope.row.dateId)">详情</el-button>
            <confirm-button type="text" style="margin: 0 10px" title="确认要删除该条数据？" @confirmed="deleteItem(scope.row.dateId)">
              <span>删除</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        dateId: "",
      },
      dateList: [],
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
    };
  },
  mounted() {
    this.loadDateList();
    this.loadTableData();
  },
  methods: {
    /**
     * 初始化历史记录领货日期列表
     */
    loadDateList() {
      this.$http({
        url: global.apiUrl + "/farm/farm-stock-history-date",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.dateList = res.body.data.dateList;
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      const bodyParams = {
        dateId: this.listParams.dateId,
        pageIndex: this.pager.pageIndex,
        pageSize: this.pager.pageSize,
      };
      this.$http({
        url: global.apiUrl + "/farm/farm-stock-history",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 进入历史记录详情页
     * @param dateId
     */
    detailItem(dateId) {
      this.$router.push({
        name: "recordDetail",
        query: {
          dateId: dateId,
        },
      });
    },
    /**
     * 删除条目数据
     * @param dateId
     */
    deleteItem(dateId) {
      this.$http({
        url: global.apiUrl + "/farm/farm-stock-history-date-delete?dateId=" + dateId,
        method: "DELETE",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadDateList();
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
